import Dictionary from "./Dictionary";
import './App.css';

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">Dictionary</header>
      <main>
        <Dictionary defaultKeyword="sunset"/>
      </main>
      <footer>
        <small>
        Coded by Laia Romero
        </small>
      </footer>
      </div>
    </div>
  );
}

